export const API_LOG_TYPE = {
  REQ: "REQ",
  RES: "RES",
  WARN: "WARN",
  ERROR: "ERROR",
}

export const URL_COMMON = {
  auth: {
    checkIpCidr: "/auth/checkIpCidr",
    callbackKakao: "/auth/callbackKakao",
    callbackNaver: "/auth/callbackNaver",
  },
}

export const URL_V1_AUTH = {
  impersonate: "/v1/auth/impersonate",
}

export const URL_V1 = {
  studentSignup: {
    schoolContext: "/v1/student-signup/school-context",
    schools: "/v1/student-signup/schools",
    applications: "/v1/student-signup/applications",
    management: "/v1/student-signup/management",
  },
  main: {
    selectMainNotice: "/v1/main/selectMainNotice",
  },
  menu: {
    selectMainMenuTree: "/v1/menu/selectMainMenuTree",
    selectMenuList: "/v1/menu/selectMenuList"
  },
  user: {
    isUserDuplicate: "/v1/user/isUserDuplicate",
    scoQuery: "/v1/user/scoQuery",
    findUserId: "/v1/user/findUserId",
    resetPw: "/v1/user/resetPw",
    resetPassword: "/v1/user/find/password",
    joinTeacher: "/v1/user/joinUser",
    firstLogin: "/v1/user/firstLogin",
    setPassword: "/v1/user/reset/password",
    agreePrivacy: "/v1/user/update/agreePrivacy",
  },
  student: {
    login: "/v1/login/login/student",
    findUserId: "/v1/user/student/findUserId",
  },
  teacher: {
    login: "/v1/login/login/teacher",
    findUserId: "/v1/user/teacher/findUserId",
  },
  login: {
    checkTeacher: "/v1/login/checkTeacher",
    login: "/v1/login/login",
    logout: "/v1/login/logout",
    userInfo: "/v1/login/get/userInfo",
    isLoginUserVerify: "/v1/login/get/isLoginUserVerify"
  },
  StudSchoReport: {
    upload: "/v1/StudSchoReport/upload",
    selectStudSchoReportList: "/v1/StudSchoReport/selectStudSchoReportList",
    selectStudSchoReportDetailList:
      "/v1/StudSchoReport/selectStudSchoReportDetailList",
    selectStudSchoReportDetailListFromGrade:
      "/v1/StudSchoReport/selectStudSchoReportDetailListFromGrade",
    getStudSchoGradeInfo: "/v1/StudSchoReport/getStudSchoGradeInfo",
    getStudSchoClssRmInfo: "/v1/StudSchoReport/getStudSchoClssRmInfo",
    getStudSchoGradeInfoFromGrade:
      "/v1/StudSchoReport/getStudSchoGradeInfoFromGrade",
    getStudSchoClssRmInfoFromGrade:
      "/v1/StudSchoReport/getStudSchoClssRmInfoFromGrade",
    updateStudSchoReportIntltsh:
      "/v1/StudSchoReport/updateStudSchoReportIntltsh",
    getStudSchoHeadInfoList: "/v1/StudSchoReport/getStudSchoHeadInfoList",
    getStudSchoHeadDetailInfoList:
      "/v1/StudSchoReport/getStudSchoHeadDetailInfoList",
    uploadItem: "/v1/StudSchoReport/uploadItem",
    calc: "/v1/StudSchoReport/calc",
    getStdSaveData:
      "/v1/StudSchoReport/selectStudSchoReportDetailListFromGrade",
    selectStdNo: "/v1/StudSchoReport/studNo",
    saveGradeCheck: "/v1/StudSchoReport/insertStudSchoReport",
    delateGradeReport: "/v1/StudSchoReport/deleteStudSchoReport",
    selectStudSchoReportListFromGrade:
      "/v1/StudSchoReport/selectStudSchoReportListFromGrade",
    getStudNo: "/v1/StudSchoReport/studNo",
  },
  RegularStudSchoReport: {
    upload: "/v1/RegularStudSchoReport/upload",
    getDetailRegularStudSchoScore:
      "/v1/RegularStudSchoReport/getDetailRegularStudSchoScore",
    calc: "/v1/RegularStudSchoReport/calc",
    uploadItem: "/v1/RegularStudSchoReport/uploadItem",
    saveStudScore: "v1/RegularStudSchoReport/saveStudScore",
    doGradeScore: "/v1/RegularStudSchoReport/doGradeScore",
    getUnivRefScoreInfo: "/v1/RegularStudSchoReport/getUnivRefScoreInfo",
    updateRegularStudScore: "/v1/RegularStudSchoReport/updateRegularStudScore",
    getConvertRegularInfo: "/v1/RegularStudSchoReport/getConvertRegularInfo",
    getUnivAlarm: "/v1/RegularStudSchoReport/getUnivAlarm",
    selectRegularNotiTable: "/v1/RegularStudSchoReport/selectRegularNotiTable",
    loadRegularStudScore: "/v1/RegularStudSchoReport/loadRegularStudScore",
    loadRegularStudScoreCount:
      "/v1/RegularStudSchoReport/loadRegularStudScoreCount",
    getRecruitTypeCount: "/v1/RegularStudSchoReport/getRecruitTypeCount"
  },
  CourseDesign: {
    departlist: "v1/course-design/depart/list",
    majorlist: "v1/course-design/major/list"
  },
  gradeConversion: {
    convert: "/v1/grade-conversions/convert",
    rules: "/v1/grade-conversions/rules",
    baseYears: "/v1/grade-conversions/base-years",
  },
  admission: {
    aiSimulator: "/v1/admission/aiSimulator",
    aiSimulatorUser: "/v1/admission/saveAiSimulatorUserData",
    selectUnivDept: "/v1/admission/selectUnivDept",
    selectSimulatorHistory: "/v1/admission/selectSimulatorHistory",
    selectUnivList: "/v1/admission/selectUnivList",
    selectDeptList: "/v1/admission/selectDeptList",
    selectMajorList: "/v1/admission/selectMajorList",
    selectSimulatorSaveList: "/v1/admission/selectSimulatorSaveList",
    selectSimulatorSaveDetail: "/v1/admission/selectSimulatorSaveDetail",
    selectAiSimulatorUserRecordData:
      "/v1/admission/selectAiSimulatorUserRecordData",
    selectStudentRecord: "/v1/admission/selectStudentRecord",
    insertSimulatorSave: "/v1/admission/insertSimulatorSave",
    runSimulator: "/v1/admission/runSimulator",
  },
  admissionCourse: {
    filter: "/v1/admission/course/filter",
    univList: "/v1/admission/course/univ-list",
    recommendSearch: "/v1/admission/course/recommend/search",
  },
  test: {
    interviewTest: {
      prompt: "/v1/test/interview-test/prompt",
      paperRuntimeInfo: "/v1/test/interview-test/paper-runtime-info",
      sessions: "/v1/test/interview-test/sessions",
      paperSessions: "/v1/test/interview-test/paper-sessions",
      sessionGenerations: (sessionKey) =>
        `/v1/test/interview-test/sessions/${sessionKey}/generations`,
      generations: "/v1/test/interview-test/generations",
      syntheticRecord: "/v1/test/interview-test/synthetic-record",
    },
    aiReport: {
      sortQuery: "/v1/test/aiReport/sortQuery",
      presentedInterview: "/v1/test/aiReport/presentedInterview",
      paperInterview: "/v1/test/aiReport/paperInterview",
      paperInterviewFollowUpQuestions: "/v1/test/aiReport/paperInterview/follow-up-questions",
      aiPaperInterview: "/v1/test/aiReport/aiPaperInterview",
      presentedInterviewExtra: "/v1/test/aiReport/presentedInterview/extra",
      paperInterviewDepartment: "/v1/test/aiReport/paperInterview/department",
      paperInterviewBook: "/v1/test/aiReport/paperInterview/book",
      paperInterviewVolunteer: "/v1/test/aiReport/paperInterview/volunteer",
      paperInterviewAward: "/v1/test/aiReport/paperInterview/award",
      paperInterviewActivities: "/v1/test/aiReport/paperInterview/activities",
      receiveReport: "/v1/test/aiReport/receiveReport",
      modelAnswer: "/v1/test/aiReport/modelAnswer",
      scoringCriteria: "/v1/test/aiReport/scoringCriteria",
      sendFile: "/v1/test/aiReport/sendFile",
      uploadAnswerVideo: "/v1/test/aiReport/uploadAnswerVideo",
      totalScore: "/v1/test/aiReport/totalScore",
      reportHistory: "/v1/test/aiReport/reportHistory",
      normalInterview: "/v1/test/aiReport/normalInterview",
      saveAiReportUserData: "/v1/test/aiReport/saveAiReportUserData",
      saveAiReportHistory: "/v1/test/aiReport/saveAiReportHistory",
      selectAiReportData: "/v1/test/aiReport/selectAiReportData",
      selectRecentlyAiReportHistoryList:
        "/v1/test/aiReport/selectRecentlyAiReportHistoryList",
      isCompleteAiReport: "/v1/test/aiReport/isCompleteAiReport",
      questionCoaching: "/v1/test/aiReport/questionCoaching",
      tts: "/v1/test/aiReport/tts",
    },
  },
  common: {
    selectCommonCodeList: "/v1/common/selectCommonCodeList",
    uploadBoardContentsImage: "/v1/common/uploadBoardContentsImage",
  },
  search: {
    selectRecommendKeywordList: "/v1/search/selectRecommendKeywordList",
  },
  event: { selectMainEventList: "/v1/event/selectMainEventList" },
  univImport: {
    essayQuestions: "/v1/univ/import/bs_interview_essay_questions",
    t2RecrImport: "/v1/univ/import/t2_recr_import",
    t2InteImport: "/v1/univ/import/t2_inte",
    t1UnivNote: "/v1/univ/import/t1_univ_note",
    univMasterRefresh: "/v1/univ/import/univ_master_refresh",
    aiSimulatorCompetitionRate: "/v1/univ/import/ai_simulator_competition_rate",
    aiSimulatorResultReportUnivData: "/v1/univ/import/ai_simulator_result_report_univ_data",
    inventory: "/v1/univ/import/inventory",
  },
  admissionCourseImport: {
    upload: "/v1/admission/course/import",
    preview: "/v1/admission/course/import/preview",
  },
  mediaBoard: {
    selectMediaBoardContentsList: "/v1/mediaBoard/selectMediaBoardContentsList",
  },
  jinhakInfo: {
    selectPassResourceAvailability: "/v1/jinhakInfo/selectPassResourceAvailability",
    selectSusiNotiTable: "/v1/jinhakInfo/selectSusiNotiTable",
    selectSusiNotiTableDetail: "/v1/jinhakInfo/selectSusiNotiTableDetail",
    selectConditionUniv: "/v1/jinhakInfo/selectConditionUniv",
    selectUnivDetail: "/v1/jinhakInfo/selectUnivDetail",
    sortQuery: "/v1/jinhakInfo/sortQuery",
    selectConditionDept: "/v1/jinhakInfo/selectConditionDept",
    selectConditionDeptDetail: "/v1/jinhakInfo/selectConditionDeptDetail",
    selectInterviewAnalysis: "/v1/jinhakInfo/selectInterviewAnalysis",
    selectInterviewAnalysisYears:
      "/v1/jinhakInfo/selectInterviewAnalysisYears",
    selectInterviewAnalysisDetail:
      "/v1/jinhakInfo/selectInterviewAnalysisDetail",
    selectSusiSuccessAnalysis: "/v1/jinhakInfo/selectSusiSuccessAnalysis",
    selectSusiSuccessAnalysisYears:
      "/v1/jinhakInfo/selectSusiSuccessAnalysisYears",
    selectSusiSuccessAnalysisDetail:
      "/v1/jinhakInfo/selectSusiSuccessAnalysisDetail",
    selectConditionDeptIntro: "/v1/jinhakInfo/selectConditionDeptIntro",
    selectConditionDeptAsso: "/v1/jinhakInfo/selectConditionDeptAsso",
    selectConditionDeptFuture: "/v1/jinhakInfo/selectConditionDeptFuture",
    deptLikeList: "/v1/jinhakInfo/deptLikeList",
    deptLike: "/v1/jinhakInfo/deptLike",
    univLikeList: "/v1/jinhakInfo/univLikeList",
    univLike: "/v1/jinhakInfo/univLike",
  },
  normalBoard: {
    selectNormalBoardContentsList:
      "/v1/normalBoard/selectNormalBoardContentsList",
    selectNormalBoardContentsDetail:
      "/v1/normalBoard/selectNormalBoardContentsDetail",
    insertNormalBoardContents: "/v1/normalBoard/insertNormalBoardContents",
    updateNormalBoardContents: "/v1/normalBoard/updateNormalBoardContents",
    deleteNormalBoardContents: "/v1/normalBoard/deleteNormalBoardContents",
  },
  QNABoard: {
    selectQNABoardContentsList: "/v1/QNABoard/selectQNABoardContentsList",
    selectQNABoardContentsDetail: "/v1/QNABoard/selectQNABoardContentsDetail",
  },
  boardComment: {
    selectBoardCommentList: "/v1/boardComment/selectBoardCommentList",
  },
  boardFile: {
    downloadFile: "/v1/boardFile/downloadFile",
    downloadFileZip: "/v1/boardFile/downloadFileZip",
  },
  myInfo: {
    selectMyInfo: "/v1/myInfo/selectMyInfo",
    updateMyInfo: "/v1/myInfo/updateMyInfo",

    updateMyInfoPassword: "/v1/myInfo/updateMyInfoPassword",
    selectLikeDeptList: "/v1/myInfo/selectLikeDeptList",
    selectLikeUnivList: "/v1/myInfo/selectLikeUnivList",
    deleteMyInfo: "/v1/myInfo/deleteMyInfo",
    passwordCheck: "/v1/myInfo/passwordCheck",
    selectAiSimulatorHistory: "/v1/myInfo/selectAiSimulatorHistory",
    sendAiSimulatorEmail: "/v1/myInfo/sendAiSimulatorEmail",
    selectAiReportHistory: "/v1/myInfo/selectAiReportHistory",
  },
  school: {
    upload: "/v1/school/student/grade/upload/schoReport",
    volunUpload: "/v1/school/student/grade/upload/volunteer",
    creativeUpload: "/v1/school/student/grade/upload/creative",
    behaviorUpload: "/v1/school/student/grade/upload/behavior",
    specialUpload: "/v1/school/student/grade/upload/special",
  },
  interview: {
    reserveStudent: '/v1/interview/reservation/student/isJoin',
    reservationTest: '/v1/interview/reservation/info'
  },
  survey: {
    isPossibleSatisfactionSurvey: '/v1/survey/isPossibleSatisfactionSurvey',
    isPossibleAnonymousSatisfactionSurvey: '/v1/survey/anonymous/isPossibleSatisfactionSurvey',
    saveSatisfaction: '/v1/survey/saveSatisfaction',
    saveAnonymousSatisfaction: '/v1/survey/anonymous/saveSatisfaction'
  },
  schoGrade: {
    allStatus: "/v1/school/student/grade/all/status",
  }
}
